import manageNews from "../manageNews/locales/ar.json";
import manageProducts from "../manageProducts/locales/ar.json";
import managePartners from "../managePartners/locales/ar.json";
import manageReferences from "../manageReferences/locales/ar.json";
import manageServices from "../manageServices/locales/ar.json";

const dashboardAR = {
  manageNews,
  manageProducts,
  managePartners,
  manageReferences,
  manageServices,
};

export default dashboardAR;
